import React, { useState, useEffect } from "react";
import { useTransition, animated } from "react-spring";
import Drugstore_item from "./Drugstore_item";
import "./Drugstore_List.module.css";
import useHttp from "../hooks/useHttp";
import SETTINGS from "../settings/settings";
import loading from "../assets/loading.gif";
import Footer from "./Footer";

const Drugstore_list = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  
  const [shopsWithPrices, setShopWithPrices] = useState([]);
  const { getDataOfProduct, isDataLoaded, currentProductData, getShipPrice } =
    useHttp();

  /**
   * Liczenie ceny dostawy dla sklepu
   */
  const calculateShipmentCost = async (isDrug, currentTotalPrice, shopData) => {
    if (isDrug) {
      if (shopData[0].kurier_cost !== null) {
        if (shopData[0].kurier_free_margin <= currentTotalPrice) return 0;
        else return parseFloat(shopData[0].kurier_cost);
      } else {
        const price = await getShipPrice(
          shopData[0].shop_id,
          currentTotalPrice,
          isDrug
        );
        if (price === null) {
          console.log("Brak ustalonej ceny!");
          return 0;
        } else return parseFloat(price);
      }
    } else {
      if (shopData[0].ship_cost !== null) {
        if (shopData[0].ship_free_margin <= currentTotalPrice) return 0;
        else return parseFloat(shopData[0].ship_cost);
      } else {
        const price = await getShipPrice(
          shopData[0].shop_id,
          currentTotalPrice,
          isDrug
        );
        if (price === null) {
          console.log("Brak ustalonej ceny!");
          return 0;
        } else return parseFloat(price);
      }
    }
  };

  /**
   * Funkcja Licząca cenę całkowitą sklepu
   */
  const getTotalPrice = async (shopData) => {
    let totalPrice = 0;
    let quantity = 0;
    let isDrug = false; /* w zamówieniu jest lek*/

    for (const medicine of shopData) {
      if (props.tagData.length > 0) {
        let selectedMedicine = props.tagData.find((tag) => {
          return tag.guid == medicine.guid;
        });
        if (selectedMedicine) quantity = selectedMedicine.quantity;

        totalPrice += quantity * medicine.value;

        if (medicine.is_lek) isDrug = true;
      }
    }
    if (props.isShipmentIncluded){
      const shipmentCost = await calculateShipmentCost(isDrug, totalPrice, shopData);
      totalPrice += shipmentCost
      return {totalPrice, shipmentCost}
    }

    return {totalPrice,shipmentCost:0};
  };

  /**
   * Funkcja licząca ceny dla wszystkich sklepów
   */
  const calculatePrices = async () => {
    let shopList = [];
    let uniqueShopIdList = [];
    setIsLoading(true);

    // shop list
    currentProductData.map((val) => {
      shopList.push(val.shop_id);
    });

    uniqueShopIdList = shopList.filter((item, i, ar) => ar.indexOf(item) === i);

    let tempProductsOfAllShops = uniqueShopIdList.map((currentShopId) => {
      const shopData = currentProductData.filter((filter_shop) => {
        return filter_shop.shop_id === currentShopId;
      });
      return { shopData, id: shopData[0].shop_id, totalPrice: 0, shipmentCost:0 };
    });
    /**
     * dla każdego sklepu
     */
    for (let i = 0; i < tempProductsOfAllShops.length; i++) {
      const totalPriceData = await getTotalPrice(
        tempProductsOfAllShops[i].shopData
      )
      tempProductsOfAllShops[i].totalPrice = totalPriceData.totalPrice
      tempProductsOfAllShops[i].shipmentCost = totalPriceData.shipmentCost
    }
    /**
     * wybranie tylko tych sklepów, które posiadają wszystkie produkty
     */
    tempProductsOfAllShops = tempProductsOfAllShops.filter((item) => {
      if (props.tagData.length == 0) return false;
      else return item.shopData.length === props.tagData.length;
    });
    tempProductsOfAllShops.sort((a, b) => {
      return a.totalPrice - b.totalPrice;
    });

    setIsLoading(false);
    setShopWithPrices(tempProductsOfAllShops);
  };

  const handleShipmentIncluded = () => {
    props.onIsShipmentIncludedChange()
  };

  useEffect(() => {
    if (props.tagData.length > 0) {
      let link = SETTINGS.priceSearch;
      for (const item of props.tagData) {
        link += "v=" + item.guid + "&";
      }
      link = link.slice(0, -1);
      getDataOfProduct(link);
      setIsLoading(true);
    }
  }, [props.tagData]);

  useEffect(() => {
    if (isDataLoaded) calculatePrices();
  }, [props.tagData, currentProductData, props.isShipmentIncluded]);

  return (
    <div className="result_contener">
      {shopsWithPrices.length > 0 && (
        <div className="header_drug_list">
          <h2 className="title is-5">
            Apteki w których są wszystkie szukane pozycje:
          </h2>
          <div>
            <label className="checkbox" htmlFor="shipment_checkbox">
              Dolicz wysyłkę
            </label>
            <input
              id="shipment_checkbox"
              type="checkbox"
              checked={props.isShipmentIncluded}
              value={props.isShipmentIncluded}
              onChange={handleShipmentIncluded}
            />
          </div>
        </div>
      )}
      {shopsWithPrices.length > 0 &&
        shopsWithPrices.map((item) => {
          return (
            <Drugstore_item
              key={item.id}
              shopData={item.shopData}
              priceSum={item.totalPrice}
              shipmentCost={item.shipmentCost}
              tagData={props.tagData}
            />
          );
        })}

      {props.tagData.length > 0 &&
        isLoading &&
        shopsWithPrices.length === 0 && (
          <img src={loading} alt="Nie wczytano obrazka" class="load" />
        )}
      {props.tagData.length > 0 &&
        !isLoading &&
        shopsWithPrices.length === 0 && (
          <h2>Nie znaleziono Apteki z takimi produktami</h2>
        )}

      {/* if( shopsWithPrices.length > 0  ) return (< Footer />) */}
    </div>
  );
};

export default Drugstore_list;
